/**
 * LUXEART — Refresh Layer (behavior)
 * Adds scroll-reveal to section-level blocks without editing
 * every section template. Respects prefers-reduced-motion.
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markSections() {
    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    sections.forEach(function (section, i) {
      if (i === 0) return; // leave the very first section (hero) alone, it's already visible on load
      section.classList.add('lx-reveal');
    });
  }

  function revealAll() {
    document.querySelectorAll('.lx-reveal').forEach(function (el) {
      el.classList.add('lx-visible');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    markSections();

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lx-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll('.lx-reveal').forEach(function (el) {
      io.observe(el);
    });
  });
})();
